// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class RevenueTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingRevenueTransactions';
        this.Server = this.props.context.getState().server.accountingRevenueTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'comment'];

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            {
                id: 'systemAccountId', required: true,
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                from: 'accountingSystemAccounts',
                object: 'systemAccount',
                show: 'name',
                displayGrid: true
            },
            { id: 'amount', required: true, label: 'amount', alignRight: true, cell: 'Amount', displayGrid: true },
            { id: 'comment', label: 'comment', alignRight: false, cell: 'BigText', displayGrid: true },
            { id: 'paymentDate', label: 'paymentDate', alignRight: false, cell: 'DateTime', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
